'use client';

import { useEffect } from 'react';
import { useAnalytics } from '@contexts/use-analytics';
import type { ListingBySlugPartial } from '@utils/imperative-node-queries';

interface ListingClientAnalyticsProps {
  listing: ListingBySlugPartial;
}

/**
 * Client-side analytics tracking for the listing page.
 * Handles setting the current listing for analytics context.
 * This component renders nothing visible - it's purely for side effects.
 */
export function ListingClientAnalytics({
  listing,
}: ListingClientAnalyticsProps) {
  const { setCurrentListing } = useAnalytics();

  useEffect(() => {
    // Track current listing for analytics when the page loads
    setCurrentListing(listing);
  }, [listing, setCurrentListing]);

  // This component renders nothing - it's purely for side effects
  return null;
}
